export const minimumMobileWidth = 768;
export const minimumTabletWidth = 1024;
